document.querySelectorAll('[data-slider-id="announcement-bar"]').forEach(function (swiper) {
  const slideshowSwiper = new Swiper(swiper, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
    },
    autoplay: {
      delay: 3000,
    }
  });
});
